import FundoscopyFacilitators from "@/views/configs/fundoscopy/index.vue";

export default [
  {
    path: "fundoscopia",
    name: "Configurações Fundoscopia",
    component: FundoscopyFacilitators,
  },
];
